import * as React from 'react';

interface H4Props {
}

const H4: React.FC<H4Props> = (props) => {
  return <h4 className="mt-4 mb-2">{props.children}</h4>
};

export default H4;